        
        
        <ng-container *ngIf="sitename === 'www.collegeessay.org' || sitename === 'www.myperfectwords.com'">

            <p><strong>Hi {{ username }},</strong></p>
 
            <p>Thanks for signing up at <strong>{{ sitename | formatSitename }}</strong> — we’re excited to have you on board!</p>
 
            <p>Your account is all set up, and you’re now ready to:</p>
            <br>
            <p>✅ Place your first academic writing order</p>
            <p>✅ Get 24/7 expert support</p>
            <p>✅ Track your orders anytime from your dashboard</p>
            <br>
            <p><strong>What’s next?</strong><br>
            You can log in at any time and start your first order whenever you're ready:</p>
 
            <p>👉 <a href="`{{sitename}}/login`">Log in to your dashboard</a></p>
 
            <p>If you have any questions or need help getting started, feel free to reply to this email. We’re always here to help.</p>
 
            <p>Welcome again — and good luck with everything ahead! 🎓</p>
 
            <p>Warmly,<br>
            <strong>The {{ sitename | formatSitename }} Team</strong></p>
            <br>
            <hr>
        </ng-container>
      
       <ng-container *ngIf="sitename !== 'www.collegeessay.org' && sitename !== 'www.myperfectwords.com'">

      
 
                        
                            <table width="100%">
                                <tr>
                                    <td>
                                        <table width="100%">
                                            <tr>
                                                <td>
                                                    <p>Hi <strong>{{ username }}</strong>,</p>
                                                    <p>Welcome aboard! Your account at <strong>{{ sitename | formatSitename }}</strong> is now active.</p>
                                                    <p>You can now:</p>
                                                    <p>
                                                        ✅ Generate up to <strong>1,500 words</strong> for free<br>
                                                        ✅ Use tools like <strong>Paraphraser, Grammar Fixer, and Citations</strong><br>
                                                        ✅ Explore <strong>Essay Rewriting, Summarizing</strong>, and more
                                                    </p>
                                                    <p>
                                                        Need help from a real academic writer?<br>
                                                        You can order a <strong>100% custom-written essay</strong> anytime — fast, confidential, and plagiarism-free.
                                                    </p>
                                                    <p>We’re here whenever you need support.</p>
                                                    <p>
                                                        —<br>
                                                        Team {{sitename | formatSitename }}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                      
            <br>
       </ng-container>
   